import React from "react";
import Icon from "@ant-design/icons";

const NewDailyReportTemplateIconSVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none">
    <path
      d="M27 4V24C27 24.2652 26.8946 24.5196 26.7071 24.7071C26.5196 24.8946 26.2652 25 26 25H9C8.46957 25 7.96086 25.2107 7.58579 25.5858C7.21071 25.9609 7 26.4696 7 27H24C24.2652 27 24.5196 27.1054 24.7071 27.2929C24.8946 27.4804 25 27.7348 25 28C25 28.2652 24.8946 28.5196 24.7071 28.7071C24.5196 28.8946 24.2652 29 24 29H6C5.73478 29 5.48043 28.8946 5.29289 28.7071C5.10536 28.5196 5 28.2652 5 28V7C5.0033 5.94015 5.42578 4.92465 6.17521 4.17521C6.92465 3.42578 7.94015 3.0033 9 3H26C26.2652 3 26.5196 3.10536 26.7071 3.29289C26.8946 3.48043 27 3.73478 27 4Z"
      fill="url(#paint0_linear_426_218)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_426_218"
        x1="16"
        y1="3"
        x2="16"
        y2="29"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#708AC2" />
        <stop offset="1" stop-color="#5673B2" />
      </linearGradient>
    </defs>
  </svg>
);

const NewDailyReportTemplateIcon = (props) => (
  <Icon component={NewDailyReportTemplateIconSVG} {...props} />
);

export default NewDailyReportTemplateIcon;
